import { useState, useEffect } from "react";

export default function ProductSkeleton() {
  const [isLoading, setIsLoading] = useState(true);

  // Demo purpose: Toggle loading state every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setIsLoading((prev) => !prev);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  // Create array of 8 items for the grid
  const skeletonItems = Array(8).fill(0);

  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      {isLoading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {skeletonItems.map((_, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden bg-white shadow"
            >
              {/* Discount badge */}
              <div className="relative h-48 bg-gray-200 animate-pulse">
                <div className="absolute top-2 left-2 w-16 h-6 bg-gray-300 rounded-md animate-pulse"></div>
                {/* Wishlist icon */}
                <div className="absolute top-2 right-2 w-8 h-8 bg-gray-300 rounded-full animate-pulse"></div>
              </div>

              {/* Product info */}
              <div className="p-4">
                {/* Category */}
                <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-24"></div>
                {/* Product name */}
                <div className="h-5 bg-gray-300 rounded animate-pulse mb-4 w-3/4"></div>

                {/* Price area */}
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center">
                    <div className="h-5 bg-gray-300 rounded animate-pulse w-16"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-14 ml-2"></div>
                  </div>
                  {/* Cart button */}
                  <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse"></div>
                </div>

                {/* Rating */}
                <div className="flex mt-3">
                  {Array(5)
                    .fill(0)
                    .map((_, i) => (
                      <div
                        key={i}
                        className="w-5 h-5 mr-1 bg-gray-200 rounded animate-pulse"
                      ></div>
                    ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
